import * as React from 'react';
import { BASE_URL } from '../../../../config/environmentConfig';
import { paymentsActionTypes } from '../payments-action-types';
import { IPaymentsAction } from '../payments-interfaces';
import { getFormattedDisputeFormFields } from '../../../constants/dispute/dispute-form';
import { formikErrorHandler } from '../../../utils/formikUtils';
import { GET, hateoasRequest } from '../../store-helper';
import { IOrderHateoasLinks } from '../../../components/orders/OrderDetails';

interface ISetDispute {
  dispatch: React.Dispatch<IPaymentsAction>;
  formik: any;
  onSuccess: () => void;
  onError: () => void;
  setError: (value: string) => void;
  orderId: string | number;
  disputeAction: IOrderHateoasLinks;
}
export const setDispute = async ({ dispatch, formik, onSuccess, onError, orderId, setError, disputeAction }: ISetDispute): Promise<void> => {
  try {
    setError('');
    if (!formik.isValid) return;
    dispatch({ type: paymentsActionTypes.SET_DISPUTE_LOADING, payload: true });
    const body = getFormattedDisputeFormFields(formik.values);
    body.orderId = orderId;

    await hateoasRequest({
      actionData: disputeAction,
      pathname: BASE_URL.PAYMENTS,
      body,
    });

    onSuccess();
    dispatch({ type: paymentsActionTypes.SET_DISPUTE_LOADING, payload: false });
  } catch (e) {
    dispatch({ type: paymentsActionTypes.FETCH_LOADING_FAIL });
    console.log('setDispute error', e.response);
    if (e.response?.data?.errors?.General) {
      setError(e.response?.data?.errors?.General[0]);
      return;
    }
    if (e.response?.data?.errors) {
      formikErrorHandler({ formik, data: e.response?.data?.errors });
      return;
    }
    onError();
  }
};

export const fetchDisputeTypes = async (dispatch: React.Dispatch<IPaymentsAction>): Promise<void> => {
  try {
    const data = await GET({
      pathname: `${BASE_URL.PAYMENTS}/Disputes/dispute-types`,
    });

    let typesList = [];
    if (data) {
      typesList = data.reduce((acc, el) => {
        const alreadyExist = acc.some(accEl => accEl?.value === el.code);
        if (alreadyExist) {
          return acc;
        } else {
          const arr = acc;
          const type = {
            value: el?.code,
            label: `${el?.name} (${el?.code})`
          };
          arr.push(type);
          return arr;
        }
      }, []);
    }
    dispatch({ type: paymentsActionTypes.FETCH_DISPUTE_TYPES, payload: typesList });
  } catch (e) {
    console.log('fetchDisputeTypes',e);
    dispatch({ type: paymentsActionTypes.FETCH_DISPUTE_TYPES, payload: [] });

  }
};